<ng-template #t let-fill="fill">
  <div class="rating-icon">
    <div class="w-embed">
      <svg
        *ngIf="fill === 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        xml:space="preserve"
      >
        <g>
          <path class="star-fill" d="M0,0h24v24H0V0z"></path>
          <path class="star-fill" d="M0,0h24v24H0V0z"></path>
        </g>
        <g>
          <path
            [ngClass]="{'star-trinidad': primary, 'star-white': !primary}"
            d="M12,17.3l6.2,3.7l-1.6-7L22,9.2l-7.2-0.6L12,2L9.2,8.6L2,9.2L7.5,14l-1.6,7L12,17.3z"
          ></path>
        </g>
      </svg>
      <svg
        *ngIf="fill < 100 && fill > 0"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        xml:space="preserve"
      >
        <path class="star-fill" d="M0,0h24v24H0V0z"></path>
        <path
          [ngClass]="{'star-trinidad': primary, 'star-white': !primary}"
          d="M22,9.2l-7.2-0.6L12,2L9.2,8.6L2,9.2L7.5,14l-1.6,7l6.2-3.7l6.2,3.7l-1.6-7L22,9.2z M12,15.4V6.1l1.7,4l4.4,0.4
l-3.3,2.9l1,4.3L12,15.4z"
        ></path>
      </svg>
      <svg
        *ngIf="fill === 0"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        xml:space="preserve"
      >
        <path class="star-fill" d="M0,0h24v24H0V0z"></path>
        <path
          [ngClass]="{'star-trinidad': primary, 'star-white': !primary}"
          d="M22,9.2l-7.2-0.6L12,2L9.2,8.6L2,9.2L7.5,14l-1.6,7l6.2-3.7l6.2,3.7l-1.6-7L22,9.2z M12,15.4l-3.8,2.3l1-4.3
l-3.3-2.9l4.4-0.4l1.7-4l1.7,4l4.4,0.4l-3.3,2.9l1,4.3L12,15.4z"
        ></path>
      </svg>
    </div>
  </div>
</ng-template>
<ng-template ngFor [ngForOf]="contexts" let-index="index">
  <span class="sr-only">({{ index < nextRate ? '*' : ' ' }})</span>
  <span
    (mouseenter)="enter(index + 1)"
    (click)="handleClick(index + 1)"
    [style.cursor]="readonly || disabled ? 'default' : 'pointer'"
  >
    <ng-template
      [ngTemplateOutlet]="starTemplate || starTemplateFromContent || t"
      [ngTemplateOutletContext]="contexts[index]"
    >
    </ng-template>
  </span>
</ng-template>
